module.exports = __webpack_public_path__ + "static/media/galerija_2022_0055.230d5b28.jpg";